import { useMutation } from 'react-query';
import { submitPortfolioProjects } from '~/api/portfolioProjects';

export const useSubmitPortfolio = (params = {}) => {
  return useMutation({
    mutationFn: async (params: { id: string; data: any}) => {
      return await submitPortfolioProjects(params.id, params.data); 
    },
    ...params
  });
};